import { Sparkles, ArrowRight } from "lucide-react";

/**
 * WelcomeScreen — pre-start surface.
 *
 * Source acknowledgment is soft (small overline). Per Sprint B lock:
 *  - Unified KCIS™ aesthetic (no per-door colors yet — door is unknown here).
 *  - No live scoring exposure.
 *  - Mobile-first tap targets.
 */
const SOURCE_LABELS = {
  "christyvonta.com": "Welcome from christyvonta.com",
  "kissedbycvon.com": "Welcome from kissedbycvon.com",
  "kisseduniversity.com": "Welcome from KISSED University",
  direct: null,
};

export default function WelcomeScreen({ sourceDomain, onBegin, beginning }) {
  const sourceLabel = SOURCE_LABELS[sourceDomain] || null;

  return (
    <section
      className="kcis-assessment-card p-8 sm:p-12 text-center kcis-fade-in"
      data-testid="kcis-welcome-screen"
    >
      {sourceLabel && (
        <p
          className="kcis-assessment-overline mb-6"
          data-testid="kcis-welcome-source"
        >
          {sourceLabel}
        </p>
      )}

      <div className="inline-flex items-center justify-center h-14 w-14 rounded-full bg-purple-50 mb-6">
        <Sparkles className="h-6 w-6 text-purple-900" />
      </div>

      <h1 className="kcis-assessment-display text-3xl sm:text-4xl lg:text-5xl leading-tight mb-4">
        Begin with a few honest reflections.
      </h1>
      <p className="text-base sm:text-lg text-slate-600 max-w-xl mx-auto leading-relaxed mb-2">
        This isn't a test. It's a quiet way to notice what's true for you right now —
        and find a doorway that meets you where you are.
      </p>
      <p className="text-sm text-slate-500 max-w-xl mx-auto leading-relaxed mb-8">
        Takes about 5–7 minutes. You can pause and come back any time —
        your reflections are saved automatically.
      </p>

      <button
        type="button"
        onClick={onBegin}
        disabled={beginning}
        data-testid="kcis-welcome-begin"
        className="inline-flex items-center gap-2 px-7 py-4 rounded-full bg-purple-900 hover:bg-purple-800 text-white text-base tracking-wide shadow-md hover:shadow-lg transition disabled:opacity-60"
      >
        {beginning ? "Beginning…" : "Begin"}
        {!beginning && <ArrowRight className="h-4 w-4" />}
      </button>

      <p className="mt-8 text-xs text-slate-400 max-w-md mx-auto">
        Wellness reflections shared here are educational and never a diagnosis.
        Review with a qualified practitioner.
      </p>
    </section>
  );
}
